const Mutations = Object.freeze({
	SET_SELECTED_INVENTORY_FORM:
		'inventoryFormModule/inventoryForm/SET_SELECTED_INVENTORY_FORM',
	SET_RECORD: 'inventoryFormModule/inventoryForm/SET_RECORD',
	SET_GRID_RECORD: 'inventoryFormModule/inventoryForm/SET_GRID_RECORD',
	SET_PK: 'inventoryFormModule/inventoryForm/SET_PK',
});

export const Actions = Object.freeze({
	CLEAR: 'inventoryFormModule/inventoryForm/CLEAR',
	CLEAR_GRID_RECORD: 'inventoryFormModule/inventoryForm/CLEAR_GRID_RECORD',
	LOAD_INVENTORY_FORM:
		'inventoryFormModule/inventoryForm/LOAD_INVENTORY_FORM',
	LOAD_GRID_VIEW_DATA:
		'inventoryFormModule/inventoryForm/LOAD_GRID_VIEW_DATA',
	LOAD_RECORD: 'inventoryFormModule/inventoryForm/LOAD_RECORD',
	LOAD_GRID_RECORD: 'inventoryFormModule/inventoryForm/LOAD_GRID_RECORD',
	SAVE: 'inventoryFormModule/inventoryForm/SAVE',
	UPDATE_RECORD_KEY: 'inventoryFormModule/inventoryForm/UPDATE_RECORD_KEY',
});

export const Getters = Object.freeze({
	SELECTED_INVENTORY_FORM:
		'inventoryFormModule/inventoryForm/SELECTED_INVENTORY_FORM',
	FORM_COLUMNS: 'inventoryFormModule/inventoryForm/FORM_COLUMNS',
	DEFAULT_GRID_VIEW: 'inventoryFormModule/inventoryForm/DEFAULT_GRID_VIEW',
	GRID_VIEWS: 'inventoryFormModule/inventoryForm/GRID_VIEWS',
	FORM_FIELDS: 'inventoryFormModule/inventoryForm/FORM_FIELDS',
	HIDDEN_FORM_FIELDS: 'inventoryFormModule/inventoryForm/HIDDEN_FORM_FIELDS',
	RECORD: 'inventoryFormModule/inventoryForm/RECORD',
	GRID_RECORD: 'inventoryFormModule/inventoryForm/GRID_RECORD',
	INTERACTIONS: 'inventoryFormModule/inventoryForm/INTERACTIONS',
});

import { GeneralActions } from '../../../../actions';
import { gridViewTypes } from '../../../../../enums/gridViewTypes';
import dataService from '../../../../../services/data/inventoryFormService';
import retainedValuesUtils from '../../../../../utils/retainedValuesUtils';
import inventoryFormRetainedValues from './inventoryFormRetainedValues';
import formFieldOnScanEditUtils from '../../../../../utils/formFieldOnScanEditUtils';

export default {
	modules: {
		inventoryFormRetainedValues,
	},
	state: {
		selectedInventoryform: null,
		record: {},
		gridRecord: null,
	},
	mutations: {
		[Mutations.SET_SELECTED_INVENTORY_FORM](state, item) {
			state.selectedInventoryform = item;
		},
		[Mutations.SET_RECORD](state, item) {
			state.record = item;
		},
		[Mutations.SET_GRID_RECORD](state, item) {
			state.gridRecord = item;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_RECORD, null);
				commit(Mutations.SET_GRID_RECORD, null);
				commit(Mutations.SET_SELECTED_INVENTORY_FORM, null);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},
		[Actions.CLEAR_GRID_RECORD]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_GRID_RECORD, null);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},
		[Actions.LOAD_INVENTORY_FORM]({ commit, dispatch }, formId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getById(formId)
					.then((resp) => {
						commit(
							Mutations.SET_SELECTED_INVENTORY_FORM,
							resp.data
						);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					});
			});
		},
		[Actions.LOAD_GRID_RECORD]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_GRID_RECORD, item.record);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},

		[Actions.LOAD_RECORD]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_RECORD, item.record);
				if (state.selectedInventoryform) {
					if (Object.keys(item.record).length == 0) {
						let values =
							inventoryFormRetainedValues.state.values.filter(
								(x) =>
									x.inventoryFormId ==
										state.selectedInventoryform.Id &&
									x.userId == item.userId
							);
						state.record =
							retainedValuesUtils.populateRetainedValues(
								item.record,
								values
							);
					}

					if (state.gridRecord) {
						let payload =
							formFieldOnScanEditUtils.getKeysValuePairToApplyOnScanEdit(
								state.selectedInventoryform,
								state.gridRecord,
								state.record
							);
						dispatch(Actions.UPDATE_RECORD_KEY, payload).then(
							() => {
								dispatch(GeneralActions.LOADING, false);
								resolve();
							}
						);
					} else {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					}
				} else {
					dispatch(GeneralActions.LOADING, false);
					resolve();
				}
			});
		},

		[Actions.LOAD_GRID_VIEW_DATA]({ dispatch }, item) {
			return new Promise((resolve) => {
				dataService
					.loadGridViewData(item)
					.then((resp) => {
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					});
			});
		},
		[Actions.UPDATE_RECORD_KEY]({ dispatch, commit, state }, keys) {
			dispatch(GeneralActions.LOADING, true);
			let record = Object.assign({}, state.record);
			keys.forEach((k) => {
				record[k.key] = k.value;
			});

			commit(Mutations.SET_RECORD, record);
			dispatch(GeneralActions.LOADING, false);
		},
		[Actions.SAVE]({ dispatch, state }, process) {
			dispatch(GeneralActions.LOADING, true);

			let formData = new FormData();
			let item = state.record;
			let itemModel = {};

			Object.keys(item).forEach((key) => {
				if (key.includes('FileUdf') && item[key]) {
					formData.append(key, item[key]);
				} else {
					itemModel[key] = item[key];
				}
			});

			let payload = {
				InventoryFormId: state.selectedInventoryform.Id,
				Row: itemModel,
			};
			formData.append('item', JSON.stringify(payload));
			return new Promise((resolve) => {
				dataService
					.saveRecord(formData, process)
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
	},
	getters: {
		[Getters.SELECTED_INVENTORY_FORM]: (state) => {
			if (!state.selectedInventoryform) return null;
			return JSON.parse(JSON.stringify(state.selectedInventoryform));
		},
		[Getters.FORM_COLUMNS]: (state) => {
			if (!state.selectedInventoryform) return 0;
			return state.selectedInventoryform.ColumnsPerRow || 1;
		},

		[Getters.DEFAULT_GRID_VIEW]: (state) => {
			if (!state.selectedInventoryform) return null;
			if (!state.selectedInventoryform.GridViews) return null;
			let entityId = state.selectedInventoryform.EntityId;
			let gv = state.selectedInventoryform.GridViews.find(
				(x) =>
					x.EntityId === entityId &&
					x.UserId === null &&
					x.Type == gridViewTypes.InventoryForm
			);
			if (gv) {
				return JSON.parse(JSON.stringify(gv));
			}
			return null;
		},
		[Getters.GRID_VIEWS]: (state) => {
			if (!state.selectedInventoryform) return [];
			if (!state.selectedInventoryform.GridViews) return [];
			return JSON.parse(
				JSON.stringify(state.selectedInventoryform.GridViews)
			);
		},

		[Getters.FORM_FIELDS]: (state) => {
			if (!state.selectedInventoryform) return [];
			if (!state.selectedInventoryform.FormFields) return [];
			if (state.selectedInventoryform.FormFields.length <= 0) return [];
			let formFields = state.selectedInventoryform.FormFields.filter(
				(x) => x.HiddenBehaviour === 0
			).sort((a, b) => a.Order - b.Order);
			return JSON.parse(JSON.stringify(formFields));
		},
		[Getters.HIDDEN_FORM_FIELDS]: (state) => {
			if (!state.selectedInventoryform) return [];
			if (!state.selectedInventoryform.FormFields) return [];
			if (state.selectedInventoryform.FormFields.length <= 0) return [];
			let formFields = state.selectedInventoryform.FormFields.filter(
				(x) => x.HiddenBehaviour > 0 && x.OnScanEdit === 0
			).sort((a, b) => a.Order - b.Order);
			return JSON.parse(JSON.stringify(formFields));
		},

		[Getters.RECORD]: (state) => {
			if (!state.record) return null;
			return JSON.parse(JSON.stringify(state.record));
		},
		[Getters.GRID_RECORD]: (state) => {
			if (!state.gridRecord) return null;
			return JSON.parse(JSON.stringify(state.gridRecord));
		},
		[Getters.INTERACTIONS]: (state) => {
			if (!state.selectedInventoryform) return [];
			if (!state.selectedInventoryform.Interactions) return [];
			return state.selectedInventoryform.Interactions;
		},
	},
};
